/**
 * ConfirmDialog public entry point (SE-5524).
 * Re-exports the container — the single shared confirm/destructive dialog
 * every delete/archive/discard flow renders.
 *
 * Named `ConfirmDestructiveDialog` until SE-8567, which renamed it because it
 * also carries non-destructive confirmations (`tone="primary"` / `"warning"`).
 * Runtime testIDs were left unchanged by the rename.
 * @module components/molecules/ConfirmDialog
 */
export { default } from "./ConfirmDialogContainer";
export type { ConfirmDialogProps } from "./ConfirmDialogContainer";
export type { ConfirmDialogTone } from "./ConfirmDialogView";
